import { RootState } from '@/app/model/store';

export const selectQuestionnaire = (state: RootState) =>
  state.marketing.questionnaire;
